import { FrontUrls } from 'Constants/FrontUrls'
import React, { lazy } from 'react'
import { Switch } from 'react-router-dom'
import { LazyRoute, filtersSlice, PAGE_SLUG } from 'Modules'
import { useUnmount } from 'Src/hooks/useUnmount'
import { useAppDispatch } from 'Src/hooks'

const MerchantStatusListLazy = lazy(
	() => import('Pages/admin/merchantStatus/components/MerchantStatusList/StatusesList')
)
const MerchantStatusEditFormLazy = lazy(
	() => import('Pages/admin/merchantStatus/components/MerchantsEditForm')
)
const MerchantStatusNewFormLazy = lazy(
	() => import('Pages/admin/merchantStatus/components/MerchantsNewForm')
)

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
}

export const MerchantStatusRoutes = () => {
	const { clearFilters } = useAppDispatch(actions)

	useUnmount(() => {
		clearFilters(PAGE_SLUG.MERCHANT_STATUS_MAPPINGS)
	})

	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.admin_panel.merchant_status}
				lazyComponent={MerchantStatusListLazy}
				key={FrontUrls.admin_panel.merchant_status}
			/>
			<LazyRoute
				exact
				path={FrontUrls.admin_panel.merchant_status_edit}
				lazyComponent={MerchantStatusEditFormLazy}
				key={FrontUrls.admin_panel.merchant_status_edit}
			/>
			<LazyRoute
				exact
				path={FrontUrls.admin_panel.merchant_status_create}
				lazyComponent={MerchantStatusNewFormLazy}
				key={FrontUrls.admin_panel.merchant_status_create}
			/>
		</Switch>
	)
}
